import React from 'react';
import SEOManagement from './SEOManagement';

const GoogleSearchConsole = () => {
  return <SEOManagement tab="console" />;
};

export default GoogleSearchConsole;
